import styled from 'styled-components';

export const HeaderContainer = styled.div<{ $denseFormat?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(1)};

  margin: ${({ theme, $denseFormat }) =>
    $denseFormat
      ? `0 ${theme.spacing(1.5)} 0 ${theme.spacing(3.5)}`
      : `${theme.spacing(2.5)} ${theme.spacing(1.5)} ${theme.spacing(1.5)} ${theme.spacing(3.5)}`};
  padding: ${({ theme }) => `${theme.spacing(2)} 0`};

  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
`;
